const GetERechargeHistoryStatusName = (id) => {
    switch (id) {
        case 0: { return "Pending" }
        case 1: { return "Failed" }
        case 2: { return "Success" }
    }
}

const GetERechargeHistoryStatus = {
    ERechargeHistoryStatus: [
        { Id: 0, Name: "Pending" },
        { Id: 1, Name: "Failed" },
        { Id: 2, Name: "Success" },
    ]
}

const ERechargeHistoryStatusBg = (id) => {
    switch (id) {
        case 0: { return "bg-orange-400" }
        case 1: { return "bg-red-400" }
        case 2: { return "bg-green-400" }
    }
}


export { GetERechargeHistoryStatusName, GetERechargeHistoryStatus, ERechargeHistoryStatusBg }